import type { ApiClientOptions } from "./client";
import { createApiClient } from "./client";

export interface RunResponse {
  id: string;
  projectId: string;
  mode: "full" | "node" | "from_here" | "resume_after";
  targetNodeId: string | null;
  status: "pending" | "running" | "completed" | "failed" | "cancelled" | "awaiting_approval";
  awaitingGateNodeId: string | null;
  createdAt: string;
  completedAt: string | null;
}

export interface NodeStatusUpdate {
  nodeId?: string;
  runId?: string;
  status: string;
  outputs?: Record<string, unknown>;
  error?: string;
  error_type?: string;
  retryable?: boolean;
  suggestion?: string;
}

export interface AgUiStreamEvent {
  nodeId: string;
  type: "TEXT_MESSAGE_START" | "TEXT_MESSAGE_CONTENT" | "TEXT_MESSAGE_END";
  message_id: string;
  delta?: string;
  role?: string;
}

export interface RunRequest {
  mode: "full" | "node" | "from_here" | "resume_after";
  targetNodeId?: string | null;
}

export interface ApprovalRequest {
  action: "approve" | "reject" | "rerun";
  nodeIds?: string[];
}

export function createRunsApi(options: ApiClientOptions) {
  const api = createApiClient(options);

  return {
    start: (projectId: string, data: RunRequest) =>
      api.post<RunResponse>(`/api/projects/${projectId}/runs`, data),

    list: (projectId: string) =>
      api.get<RunResponse[]>(`/api/projects/${projectId}/runs`),

    get: (projectId: string, runId: string) =>
      api.get<RunResponse>(`/api/projects/${projectId}/runs/${runId}`),

    cancel: (projectId: string, runId: string) =>
      api.post<void>(`/api/projects/${projectId}/runs/${runId}/cancel`),

    approve: (projectId: string, runId: string, data: ApprovalRequest) =>
      api.post<RunResponse | null>(`/api/projects/${projectId}/runs/${runId}/approval`, data),

    latestNodeOutputs: (projectId: string) =>
      api.get<Record<string, { outputs: Record<string, unknown>; runId: string; completedAt: string | null }>>(
        `/api/projects/${projectId}/runs/latest-node-outputs`
      ),
  };
}
